module.exports = __webpack_public_path__ + "media/images/favicon-80cf3f30e967be3cae904f73f43a33df.png";